const DATA = [
  {
    id: 1,
    header: "Cabs (Own Concept) ",
    titleLine1: "Best in cab experience for",
    titleLine2: "the passengers",
    tagLine: "UX Design, UI Design",
    image: "./works/home-cabapp.jpg",
    imageName: "cabapp",
    color: "#EFEDF5",
    cursor: "#6200EF",
  },
  {
    id: 2,
    header: "Farmer (Own Concept)",
    titleLine1: "Esay way to calculate",
    titleLine2: "Harvest Time",
    tagLine: "UX Design, UI Design",
    image: "./works/home-farmer.jpg",
    imageName: "farmer",
    color: "#EEF6F1",
    cursor: "#56BC7D",
  },
  {
    id: 3,
    header: "Melloframes",
    titleLine1: "Branding, Storytelling,",
    titleLine2: "Digital Experiences.",
    tagLine: "UX Design, UI Design",
    image: "./works/home-mellowframes.jpg",
    imageName: "mellowframes",
    color: "#F9F1F4",
    cursor: "#F8015A",
  },
  {
    id: 4,
    header: "Mulackal",
    titleLine1: "Asian Cuisines",
    titleLine2: "for europian",
    tagLine: "UX Design, UI Design",
    image: "./works/home-kitchen.jpg",
    imageName: "kitchen",
    color: "#F6EEED",
    cursor: "#F34850",
  },
]

export default DATA
